const words = [
  "Reel Instagram",
  "Video Promo",
  "Matrimoni",
  "Interviste",
  "Color Grading",
  "Sound Design",
  "Riprese Sony a6400",
  "Editing Cinematico",
];

export default function Marquee() {
  const loop = [...words, ...words];
  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-white/10 py-6 overflow-hidden bg-graphite-950"
    >
      <div className="flex gap-12 animate-marquee whitespace-nowrap">
        {loop.map((w, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="font-display text-2xl md:text-3xl text-white/40">{w}</span>
            <span className="text-gold text-xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
